import { makeStyles, Paper, TextField, Theme, Typography } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import React from 'reactn';
import { NumberField } from '../../components/NumberField';
import { SectionTitle } from '../../components/SectionTitle';
import { DefaultInputProps } from '../../types/types';
import { globalStyles } from '../../style/GlobalStyles';

// const useStyles = makeStyles((theme: Theme) =>
//     createStyles({
//         formControl: {
//             margin: theme.spacing(1),
//             // minWidth: 320,
//         },
//         textField: {
//             marginLeft: theme.spacing(1),
//             marginRight: theme.spacing(1),
//             width: 200,
//         },
//         bottomControlLabel: {
//             verticalAlign: 'bottom',
//         }
//     }),
// );

export default function Collaboratore1(props: DefaultInputProps) {
    // const classes = useStyles();
    const gClasses = globalStyles();
    const { state } = props;

    return (
        <React.Fragment>
            {state.datiCollaboratore1.nomeCognome1 !== undefined && state.datiCollaboratore1.nomeCognome1 !== "" ?
                (<Paper className={gClasses.mainPaper}>
                    <SectionTitle text="Collaboratore 1"></SectionTitle>
                    <TextField
                        label="Collaboratore 1"
                        value={state.datiCollaboratore1.nomeCognome1}
                        className={gClasses.textFieldReadOnly}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        inputProps={{tabIndex: -1}}
                        margin="normal"
                    />
                    <NumberField
                        name=""
                        label="Rivalsa Contr. IVS"
                        value={state.collaboratore1.rivalsaContrIvs_H33}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <Typography variant="h5">Redditi</Typography>
                    <NumberField
                        name="redditiDiversiDallaPartecipazione_E111"
                        label="Pensione"
                        value={state.datiCollaboratore1.redditiDiversiDallaPartecipazione_E111}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name="redditiDiversiDallaPartecipazione_E112"
                        label="Lav. dipendente e assimilati"
                        value={state.datiCollaboratore1.redditiDiversiDallaPartecipazione_E112}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name="redditiDiversiDallaPartecipazione_E113"
                        label="Assimilati lav. dipendente"
                        value={state.datiCollaboratore1.redditiDiversiDallaPartecipazione_E113}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name="redditiDiversiDallaPartecipazione_E114"
                        label="Diversi lettere i) e l)"
                        value={state.datiCollaboratore1.redditiDiversiDallaPartecipazione_E114}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name="redditiDiversiDallaPartecipazione_E115"
                        label="Fabbricati locati"
                        value={state.datiCollaboratore1.redditiDiversiDallaPartecipazione_E115}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name="redditiDiversiDallaPartecipazione_E116"
                        label="Altri"
                        value={state.datiCollaboratore1.redditiDiversiDallaPartecipazione_E116}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name="redditiDiversiDallaPartecipazione_E117"
                        label="Abitazione principale"
                        value={state.datiCollaboratore1.redditiDiversiDallaPartecipazione_E117}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name="redditiDiversiDallaPartecipazione_E119"
                        label="Redditi a cedolare secca"
                        value={state.datiCollaboratore1.redditiDiversiDallaPartecipazione_E119}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name="redditi_E46"
                        label="Reddito complessivo"
                        value={state.collaboratore1.redditi_E46}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name="redditi_E47"
                        label="Redd. compl. per detraz."
                        value={state.collaboratore1.redditi_E47}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name="oneriDeducibiliredditi_I35"
                        label="Oneri deducibili"
                        value={state.collaboratore1.oneriDeducibiliredditi_I35}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name="redditoImponibile_I36"
                        label="Reddito imponibile"
                        value={state.collaboratore1.redditoImponibile_I36}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name="irpefLorda_I37"
                        label="Irpef lorda"
                        value={state.collaboratore1.irpefLorda_I37}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <Typography variant="h5">Detrazioni</Typography>
                    <NumberField
                        name="familiari_I39"
                        label="Familiari a carico"
                        value={state.collaboratore1.familiari_I39}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name="lavDip_I40"
                        label="Lavoro dipend."
                        value={state.collaboratore1.lavDip_I40}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name="pensione_I41"
                        label="Pensione"
                        value={state.collaboratore1.pensione_I41}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name="lavNonDip_I42"
                        label="Lav. non dipend."
                        value={state.collaboratore1.lavNonDip_I42}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name="altriDatiPersonali_L115"
                        label="Altre"
                        value={state.datiCollaboratore1.altriDatiPersonali_L115}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name="totDetr_I44"
                        label="Tot. Detrazioni"
                        value={state.collaboratore1.totDetr_I44}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name="irpefNetta_M40"
                        label="Irpef netta"
                        value={state.collaboratore1.irpefNetta_M40}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <Typography variant="h5">Addizionali Irpef</Typography>
                    <NumberField
                        name="regionale_K44"
                        label="Regionale"
                        value={state.collaboratore1.regionale_K44}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name="comunale_M44"
                        label="Comunale"
                        value={state.collaboratore1.comunale_M44}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                </Paper>) : <p></p>}
        </React.Fragment>
    );
}